/**
 * @generated SignedSource<<1633abb5e0e1a7e6e072b3b412d26972>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateOpportunityModal_Query$variables = {};
export type CreateOpportunityModal_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly company: {
      readonly id: string;
      readonly projectLastSequence: number | null;
      readonly currency: string | null;
      readonly opportunityStageBands: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly startPercentage: number | null;
            readonly endPercentage: number | null;
            readonly winProbability: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly defaultRateCard: {
        readonly id: string;
        readonly name: string | null;
        readonly currency: string | null;
      } | null;
      readonly rateCards: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly currency: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly clients: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | null> | null;
      } | null;
      readonly allPersons: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly fullName: string | null;
            readonly active: boolean | null;
          } | null;
        } | null> | null;
      } | null;
      readonly labels: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly color: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly modules: ReadonlyArray<{
        readonly moduleType: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type CreateOpportunityModal_Query = {
  variables: CreateOpportunityModal_Query$variables;
  response: CreateOpportunityModal_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "create_opportunity_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"create_opportunity_modal\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectLastSequence",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1000
    }
  ],
  "concreteType": "OpportunityStageBandTypeConnection",
  "kind": "LinkedField",
  "name": "opportunityStageBands",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OpportunityStageBandTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OpportunityStageBand",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endPercentage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "winProbability",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "opportunityStageBands(first:1000)"
},
v7 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "defaultRateCard",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": (v10/*: any*/),
  "concreteType": "RateCardTypeConnection",
  "kind": "LinkedField",
  "name": "rateCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCardTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rateCards(first:10000)"
},
v12 = {
  "alias": null,
  "args": (v10/*: any*/),
  "concreteType": "ClientTypeConnection",
  "kind": "LinkedField",
  "name": "clients",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "clients(first:10000)"
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "excludeClientUsers",
      "value": true
    },
    (v9/*: any*/),
    {
      "kind": "Literal",
      "name": "onlyActive",
      "value": true
    }
  ],
  "concreteType": "PersonTypeConnection",
  "kind": "LinkedField",
  "name": "allPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "allPersons(excludeClientUsers:true,first:10000,onlyActive:true)"
},
v14 = {
  "alias": null,
  "args": [
    (v9/*: any*/),
    {
      "kind": "Literal",
      "name": "labelType",
      "value": "PROJECT"
    }
  ],
  "concreteType": "LabelTypeConnection",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "labels(first:10000,labelType:\"PROJECT\")"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moduleType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOpportunityModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateOpportunityModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae6d165ffde7b318cae1767b120eeba4",
    "id": null,
    "metadata": {},
    "name": "CreateOpportunityModal_Query",
    "operationKind": "query",
    "text": "query CreateOpportunityModal_Query {\n  viewer {\n    actualPersonId\n    component(name: \"create_opportunity_modal\")\n    company {\n      id\n      projectLastSequence\n      currency\n      opportunityStageBands(first: 1000) {\n        edges {\n          node {\n            id\n            name\n            startPercentage\n            endPercentage\n            winProbability\n          }\n        }\n      }\n      defaultRateCard {\n        id\n        name\n        currency\n      }\n      rateCards(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            currency\n          }\n        }\n      }\n      clients(first: 10000) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      allPersons(first: 10000, onlyActive: true, excludeClientUsers: true) {\n        edges {\n          node {\n            id\n            fullName\n            active\n          }\n        }\n      }\n      labels(first: 10000, labelType: PROJECT) {\n        edges {\n          node {\n            id\n            name\n            color\n          }\n        }\n      }\n      modules {\n        moduleType\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0b7277280f653522d8ead4af2f2da3f";

export default node;
